"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAttributesWithValue = exports.attributeToAttributeInput = exports.attributesToMap = exports.getAttributeValueByKey = exports.getAttributeByKey = void 0;
function getAttributeByKey(attributes, key) {
    return attributes.find(attribute => attribute.key === key);
}
exports.getAttributeByKey = getAttributeByKey;
function getAttributeValueByKey(attributes, key, defaultValue = "") {
    var _a, _b;
    return (_b = (_a = getAttributeByKey(attributes, key)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : defaultValue;
}
exports.getAttributeValueByKey = getAttributeValueByKey;
function attributesToMap(attributes) {
    return Object.fromEntries(attributes.map(attribute => [attribute.key, attribute.value]));
}
exports.attributesToMap = attributesToMap;
function attributeToAttributeInput(attribute) {
    var _a;
    return {
        key: attribute.key,
        value: (_a = attribute.value) !== null && _a !== void 0 ? _a : "",
    };
}
exports.attributeToAttributeInput = attributeToAttributeInput;
/**
 * Updates the value of an attribute in a list, adding it if necessary or removing it if the new
 * value is empty.
 */
function updateAttributesWithValue(attributes, key, newValue) {
    const exists = !!getAttributeByKey(attributes, key);
    const attributeInputs = attributes.map(attributeToAttributeInput);
    if (exists) {
        if (newValue) {
            return attributeInputs.map(attribute => {
                if (attribute.key === key) {
                    return {
                        key,
                        value: newValue,
                    };
                }
                else {
                    return attribute;
                }
            });
        }
        else {
            // Remove it
            return attributeInputs.filter((attribute) => attribute.key !== key);
        }
    }
    else if (newValue) {
        return [...attributeInputs, { key, value: newValue }];
    }
    else {
        return attributeInputs;
    }
}
exports.updateAttributesWithValue = updateAttributesWithValue;
//# sourceMappingURL=data:application/json;base64,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